import { createContext, useContext, ReactNode, useMemo } from 'react';
import { User, Session } from '@supabase/supabase-js';

interface UserContextType {
  user: User | null;
  session: Session | null;
  userId: string | null;
  isAdmin: boolean;
  metadata: {
    profile: any;
    isAdmin: boolean;
    settings: any;
  } | null;
  updateUserMetadata: (update: any) => void;
}

const UserContext = createContext<UserContextType>({
  user: null,
  session: null,
  userId: null,
  isAdmin: false,
  metadata: null,
  updateUserMetadata: () => { },
});

export const UserProvider = ({
  children,
  user,
  session,
  metadata,
  isAdmin,
  updateUserMetadata
}: {
  children: ReactNode;
  user: User | null;
  session: Session | null;
  metadata: any;
  isAdmin: boolean;
  updateUserMetadata: (update: any) => void;
}) => {
  const value = useMemo(() => ({
    user,
    session,
    userId: user?.id ?? null,
    isAdmin,
    metadata,
    updateUserMetadata
  }), [user, session, isAdmin, metadata, updateUserMetadata]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  return context;
};

// Hook to get just the user ID (most common use case)
export const useUserId = () => {
  const { userId } = useContext(UserContext);
  return userId;
};

